// extracted by mini-css-extract-plugin
export default {"photo":"GuildPhotoBox_photo__NILm0"};